import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { WarningComponent } from '../../warning/warning.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { QuotingToolService } from '../../quoting-tool.service';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-view-e-quote',
  templateUrl: './view-e-quote.component.html'
})
export class ViewEQuoteComponent implements OnInit {

  imagePath:any=environment.image_path;
  memberDomain:any=environment.member_domain;
  projectID:any;
  uniqueID:any;

  quotationDetails:any;
  previousData: any; // Track previous data
  getStoreData: any

  @Output() userDetails = new EventEmitter<string>();

  addNewItem(value: string) {
    this.userDetails.emit(value);
  }

  localToken: any;
  isAccessTokenPresent: boolean = !!localStorage.getItem('quote_token') || !!localStorage.getItem('customer_access_token');

  private isModalOpen = false; // Track modal state
  constructor(public commonService: CommonService,private authService:AuthenticationService,private notifyService: NotificationService,private quotingService:QuotingToolService,private router: Router,public dialog: MatDialog) { }

  ngOnInit(): void {
    localStorage.setItem('currentStepIndex', '2');
    this.projectID = localStorage.getItem('projectID');
    this.uniqueID = localStorage.getItem('ID');
    
    this.GetQuotation();
  }

  GoToDashboard() {
    const accessToken = localStorage.getItem('customer_access_token');
    if(accessToken){
      this.router.navigate(['/customer/quotation-proposal'])
    } else {
      let token=localStorage.getItem('quote_token');
      if(token){
        window.open(this.memberDomain + `/member/quotation-proposal`, '_blank');
        window.close();
      }else{
        this.router.navigate([''])
      }
    }
  }

  GetQuotation(){
    const customer_access_token=localStorage.getItem('customer_access_token');
    const quote_token=localStorage.getItem('quote_token');

    const tempFunction = this.commonService.getQuoteCallback(); // Get the initial value
    this.getStoreData = tempFunction();
    this.previousData = tempFunction();
    if(customer_access_token || quote_token){
      this.isAccessTokenPresent=true;
    }else{
      this.isAccessTokenPresent=false;
    }
    // if(this.router.url == "/quotation"){
    //   return;  
    // }
      if (!this.isAccessTokenPresent) {
        this.isModalOpen = true; // Set the modal state to open
        const dialogRef = this.dialog.open(WarningComponent, {
          width: '500px',
          disableClose: true,
          panelClass: 'custom-dialog'
        });
        

        const intervalId = setInterval(() => {
          const currentDataFunc = this.commonService.getQuoteCallback(); // Get the current value
          const currentData = currentDataFunc();
    
          if (this.previousData && (currentData !== this.previousData)) {
    
            this.isAccessTokenPresent = true; // Update the token presence
            this.isModalOpen = false; // Close the modal
            this.GetUserData();
            this.GetEngineeringQuotation(); // Call your API whenever data changes
    
            // Clear the interval
            clearInterval(intervalId);
          }
        }, 1000);
  
  
        dialogRef.afterClosed().subscribe(() => {
          this.isModalOpen = false; // Reset the modal state after it closes
        });
      } else {
        // this.quotationDetails={"iCreatedAt":1734081852,"iProductMinRange":null,"iProductMaxRange":null,"vProjectName":"Test EQuote 13121454","vProductDocuments":[""],"isProductRangeUnknown":true,"quoteArray":[{"iServiceRequirementId":"675c01644cb5a62ff31c1ac5","iMasterServiceId":"675c00734e27bac930294328","vMasterServiceTitle":"Hardware","vMasterServiceDescription":"Schematic","totalScore":15},{"iServiceRequirementId":"675c01644cb5a62ff31c1ac7","iMasterServiceId":"675c009d4cb5a62ff31c1ac0","vMasterServiceTitle":"Web Cloud Application","vMasterServiceDescription":"Admin, User, Frontend, Backend","totalScore":15},{"iServiceRequirementId":"675c01644cb5a62ff31c1ac9","iMasterServiceId":"675c00b95290d0107305c342","vMasterServiceTitle":"Mechanical","vMasterServiceDescription":"","totalScore":0}],"grandTotalScore":30}
        this.GetEngineeringQuotation();
      }
      
  }

  GetUserData() {
    this.authService.GetProfileData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.addNewItem(resJSON.data);
      } else {
        this.notifyService.showError(`${resJSON.message}`, '');
      }
    });
  }

  GetEngineeringQuotation(){
    this.quotingService.GetEngineeringQuotation(this.uniqueID).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.quotationDetails=result['data'];
      } else {
        this.notifyService.showError(result.message, '');
      }
    });
  }

}
